import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandHeader from "@/components/BrandHeader";
import Footer from "@/components/Footer";

export default function Impressum() {
  return (
    <div className="min-h-screen relative z-10" data-testid="impressum-page">
      <BrandHeader minimal />
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-white/50 hover:text-brand-orange transition-colors">
          <ArrowLeft className="h-4 w-4" /> Zur Startseite
        </Link>
        <h1 className="mt-8 font-display uppercase text-3xl tracking-tight text-white">Impressum</h1>
        <div className="mt-8 space-y-6 text-sm text-white/70 leading-relaxed">
          <div>
            <p className="text-white font-semibold">Florian Ebert</p>
            <p>feNANCE Controlling Systems</p>
            <p>Eduard-Dressler-Str. 1</p>
            <p>63762 Großostheim</p>
          </div>
          <div>
            <p className="text-white font-semibold mb-1">Kontakt</p>
            <p>Telefon: +49 (0) 60 26 / 99 600 65</p>
            <p>E-Mail: <a href="mailto:fe@fenance.de" className="text-brand-orange hover:underline">fe@fenance.de</a></p>
          </div>
          <div>
            <p className="text-white font-semibold mb-1">Umsatzsteuer-ID</p>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE273935446</p>
          </div>
          <div>
            <p className="text-white font-semibold mb-1">Verbraucherstreitbeilegung / Universalschlichtungsstelle</p>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
